import { Button, Modal } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { formatDate } from "../../utils/Utils";
import Pdf from "react-to-pdf";

const Invoice = ({ storeCurrency, order, ship }) => {
  const products = useSelector((state) => state?.orders)?.products;

  const options = {
    orientation: "landscape",
    unit: "in",
    format: [10, 6],
  };

  const ref = React.createRef();

  const [open, setOpen] = useState(false);

  const getCartSubTotal = () => {
    return products
      ?.reduce(
        (price, item) => price + item.product.price * item.quantity,
        0 + ship
      )
      ?.toFixed(2);
  };

  const getTotal = () => {
    return products
      ?.reduce((price, item) => price + item.product.price * item.quantity, 0)
      ?.toFixed(2);
  };

  return (
    <div>
      <Button type="primary" onClick={() => setOpen(true)}>
        View Invoice
      </Button>
      <Modal
        title={`Invoice`}
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width={1000}
        footer={[
          <Pdf targetRef={ref} filename={`${order?._id}.pdf`} options={options}>
            {({ toPdf }) => (
              <>
                <Button type="primary" onClick={toPdf}>
                  Download Invoice
                </Button>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
              </>
            )}
          </Pdf>,
        ]}
      >
        <div className="invoice px-4" ref={ref}>
          <div>
            <div className="invoice-title">
              <h3 className="pull-right">Order # {order?._id}</h3>
            </div>
            <hr className="mb-4" />
            <div className="md:grid md:grid-cols-2">
              <div>
                <address>
                  <strong>Billed To:</strong>
                  <br />
                  {order?.user?.name}
                  <br />
                  {order?.billingAddress} {order?.shippingAddressCity}{" "}
                  {order?.billingAddressState}, {order?.billingAddressCountry},{" "}
                  {order?.billingAddressZip}
                </address>
              </div>
              <div className="text-right">
                <address>
                  <strong>Shipped To:</strong>
                  <br />
                  {order?.user?.name}
                  <br />
                  {order?.shippingAddress} {order?.shippingAddressCity}{" "}
                  {order?.shippingAddressState}, {order?.shippingAddressCountry}
                  , {order?.shippingAddressZip}
                </address>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 mb-4">
              <div>
                <strong>Payment Method:</strong>
                <br />
                {order?.paymentMethod}
                <br />
                {order?.user?.email}
              </div>
              <div className="text-right">
                <strong>Order Date:</strong>
                <br />
                {formatDate(order?.dateOrdered)}
                <br />
                <br />
              </div>
            </div>
          </div>
          <div className="panel panel-default ">
            <div className="panel-heading">
              <h3 className="panel-title">
                <strong>Order summary</strong>
              </h3>
            </div>
            <div className="panel-body">
              <div className="table-responsive">
                <table className="table table-condensed w-full">
                  <thead>
                    <tr>
                      <td>
                        <strong>Item</strong>
                      </td>
                      <td className="text-center">
                        <strong>Price</strong>
                      </td>
                      <td className="text-center">
                        <strong>Quantity</strong>
                      </td>
                      <td className="text-right">
                        <strong>Total</strong>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {products?.length > 0
                      ? products?.map((o, index) => (
                          <tr key={index}>
                            <td>{o?.product?.name}</td>
                            <td className="text-center">
                              {storeCurrency}
                              {o?.product?.price}
                            </td>
                            <td className="text-center">{o?.quantity}</td>
                            <td className="text-right">
                              {storeCurrency}
                              {o?.product?.price}
                            </td>
                          </tr>
                        ))
                      : ""}

                    <tr>
                      <td className="thick-line" />
                      <td className="thick-line" />
                      <td className="thick-line text-center">
                        <strong>Subtotal</strong>
                      </td>
                      <td className="thick-line text-right">
                        {storeCurrency}
                        {getTotal()}
                      </td>
                    </tr>
                    <tr>
                      <td className="no-line" />
                      <td className="no-line" />
                      <td className="no-line text-center">
                        <strong>Shipping</strong>
                      </td>
                      <td className="no-line text-right">
                        {storeCurrency}
                        {ship}
                      </td>
                    </tr>
                    <tr>
                      <td className="no-line" />
                      <td className="no-line" />
                      <td className="no-line text-center">
                        <strong>Total</strong>
                      </td>
                      <td className="no-line text-right">
                        {storeCurrency}
                        {getCartSubTotal()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Invoice;
